import React, { useState, useEffect, useRef, useContext } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Tabs,
    Tab,
    Box
} from '@mui/material';
import { TABS_STYLE, TAB_ITEM_STYLE } from "../../../styles/CommonStyles";
import SharedDataContext from "../../../_helper/SharedData";
import CreateEditPayoutForm from './CreateEditPayoutForm';
import CreateEditPayoutMappingForm from './CreateEditPayoutMappingForm';

const PayoutForm = ({ open, onClose, onSuccess, initialTab = 0 }) => {
    const { globalCityField } = useContext(SharedDataContext);
    const serviceCityId = globalCityField?.value?.id;
    const [tabValue, setTabValue] = useState(initialTab);
    const payoutFormRef = useRef(null);

    useEffect(() => {
        if (open) {
            setTabValue(initialTab);
        }
    }, [open, initialTab]);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const handleClose = () => {
        setTabValue(0);
        onClose();
    };

    const handlePayoutSuccess = () => {
        // Switch to Create Mapping tab after payout creation
        setTabValue(1);
        // Don't call onSuccess here - wait until mapping is complete
    };

    const handleMappingSuccess = () => {
        // After mapping is created, refresh data and close
        onSuccess();
    };

    const handleNextClick = () => {
        // Trigger submit on CreateEditPayoutForm
        if (payoutFormRef.current) {
            payoutFormRef.current.submit();
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
            <DialogTitle sx={{ fontWeight: 600 }}>
                Driver Payout
            </DialogTitle>
            <DialogContent dividers className="p-0">
                <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, pt: 1 }}>
                    <Tabs value={tabValue} onChange={handleTabChange} sx={TABS_STYLE}>
                        <Tab label="Payouts" sx={TAB_ITEM_STYLE} disableRipple />
                        <Tab label="Tariff & Payout Mapping" sx={TAB_ITEM_STYLE} disableRipple />
                    </Tabs>
                </Box>

                {/* Tab 0: Create Payout */}
                <div role="tabpanel" hidden={tabValue !== 0}>
                    {tabValue === 0 && (
                        <CreateEditPayoutForm
                            ref={payoutFormRef}
                            open={open}
                            onClose={handleClose}
                            onSuccess={handlePayoutSuccess}
                            editData={null}
                            standalone={false}
                        />
                    )}
                </div>

                {/* Tab 1: Create Mapping */}
                <div role="tabpanel" hidden={tabValue !== 1}>
                    {tabValue === 1 && (
                        <CreateEditPayoutMappingForm
                            serviceCityId={serviceCityId}
                            onSuccess={handleMappingSuccess}
                            onCancel={handleClose}
                        />
                    )}
                </div>
            </DialogContent>
            
            {/* Dialog Actions - Only for Tab 0 */}
            {tabValue === 0 && (
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={handleClose} color="inherit">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleNextClick}
                        sx={{ 
                            bgcolor: '#39B54A',
                            '&:hover': { bgcolor: '#2d9140' },
                        }}
                    >
                        Next
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default PayoutForm;
